import { addPhoneFormatterToKeyupEvent } from "../../AcademyUtilities";

$(function () { 
    const PARENT_CONTAINER = $("#registration-parent");
    const RegistrationForm = $('#registration-form');
    const AffiliationBox = $('#AccountFormVM_Affiliated');

    PARENT_CONTAINER.on('change', '#AccountFormVM_Country', function () {
        var country = $(this).val();
        filterStateOptions(country);
    });

    PARENT_CONTAINER.on('change', '#AccountFormVM_OrgCountry', function () {
        var orgCountry = $(this).val();
        filterStateOptions(orgCountry, true);
    });

    function filterStateOptions(country, isOrg = false) {
        $.ajax(
            {
                type: "GET",
                url: './Register?handler=StatesByCountry',
                data: { country: country },
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("XSRF-TOKEN",
                        <string>$('input:hidden[name="__RequestVerificationToken"]').val());
                }
            })
            .done(function (data) {
                if (data.length) {
                    var stateOptions;
                    if (isOrg) {
                        enableControl($('#OrgStateOpenTextBlock'), $("#AccountFormVM_OrgInternationalProvince"), false);
                        enableControl($('#OrgStateDropdownBlock'), $("#AccountFormVM_OrgState"), true);
                        stateOptions = $('#AccountFormVM_OrgState').find('option').not("[value='']");
                        stateOptions.remove();
                        $.each(data, function (index, value) {
                            var option = '<option value=' + value.value + '>' + value.text + '</option>';
                            $("#AccountFormVM_OrgState").append(option);
                        });
                    } else {
                        enableControl($('#StateOpenTextBlock'), $("#AccountFormVM_InternationalProvince"), false);
                        enableControl($('#StateDropdownBlock'), $("#AccountFormVM_State"), true);
                        stateOptions = $('#AccountFormVM_State').find('option').not("[value='']");
                        stateOptions.remove();
                        $.each(data, function (index, value) {
                            var option = '<option value=' + value.value + '>' + value.text + '</option>';
                            $("#AccountFormVM_State").append(option);
                        });
                    }
                } else {
                    if (isOrg) {
                        showOrgInternational();
                    } else {
                        showInternational();
                    }
                }
            })
            .fail(function (data) {
                console.log('StatesByCountry Error');
            })
            .always(function (data) {
                console.log('always');
            });
    }

    function enableControl(blockElement, inputElement, enabled) {
        if (enabled) {
            blockElement.show();
            inputElement.prop('disabled', false);
        } else {
            blockElement.hide();
            inputElement.prop('disabled', true);
        }
    }

    function showInternational() {
        enableControl($('#StateOpenTextBlock'), $("#AccountFormVM_InternationalProvince"), true);
        enableControl($('#StateDropdownBlock'), $("#AccountFormVM_State"), false);
    }

    function showOrgInternational() {
        enableControl($('#OrgStateOpenTextBlock'), $("#AccountFormVM_OrgInternationalProvince"), true);
        enableControl($('#OrgStateDropdownBlock'), $("#AccountFormVM_OrgState"), false);
    }

    addPhoneFormatterToKeyupEvent('AccountFormVM_OrgPhone');
    addPhoneFormatterToKeyupEvent('AccountFormVM_Phone');
 
    // toggle the school/org fields when the input is clicked.
    RegistrationForm.on('change', '#AccountFormVM_Affiliated', toggleOrgDisplay);

    function toggleOrgDisplay() {
        const OrgInfo = $('div.school-org-info');
        const OrgInfoInput = $('div.school-org-info input');
        const AccountFormVM_OrgCountry = $('#AccountFormVM_OrgCountry');
        OrgInfo.toggle();
        OrgInfoInput.val('');
        if (OrgInfo.is(":visible")) {
            AccountFormVM_OrgCountry.val("US");
        } else {
            AccountFormVM_OrgCountry.val('');
        }
    }

});